import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useTrans } from "../hooks/useTrans";
import {
    DashboardPage,
    DonationTransactionPage,
    ForgotPasswordPage,
    LoginPage,
    ProfilePage,
    SetPasswordPage,
    TokenLoginPage,
    UserPage,
} from "../pages";
import { useAuthAction } from "../hooks";
import { cPath } from "../config";

const AdminLayout = lazy(() => import("../layout/AdminLayout"));
// const HomeLayout = lazy(() => import("../layout/HomeLayout"));
const LoginLayout = lazy(() => import("../layout/LoginLayout"));

const Logout = () => {
    const { logoutAction } = useAuthAction();
    logoutAction();
    return <></>;
};

const RootRoutes = ({ isAuthenticated }: { isAuthenticated: boolean }) => {
    const { t } = useTrans();
    return (
        <Routes>
            {isAuthenticated ? (
                <>
                    <Route
                        path="*"
                        element={
                            <Navigate
                                to={cPath("ADMIN.DASHBOARD_PAGE")}
                                replace
                            />
                        }
                    />
                    <Route
                        path={cPath("ADMIN")}
                        element={
                            <Suspense fallback={<>{t("Loading")}</>}>
                                <AdminLayout />
                            </Suspense>
                        }
                    >
                        <Route
                            path={cPath("ADMIN.DASHBOARD_PAGE", {}, true)}
                            element={<DashboardPage />}
                        />
                        <Route
                            path={cPath("ADMIN.PROFILE_PAGE", {}, true)}
                            element={<ProfilePage />}
                        />
                        <Route
                            path={cPath("ADMIN.USER_PAGE", {}, true)}
                            element={<UserPage />}
                        />
                        <Route
                            path={cPath(
                                "ADMIN.USER_PAGE_EDIT",
                                { id: ":id" },
                                true
                            )}
                            element={<UserPage />}
                        />
                        <Route
                            path={cPath("ADMIN.DONER_PAGE", {}, true)}
                            element={
                                <div>
                                    <UserPage />
                                </div>
                            }
                        />
                        <Route
                            path={cPath(
                                "ADMIN.DONATION_TRANSACTION_PAGE",
                                {},
                                true
                            )}
                            element={<DonationTransactionPage />}
                        />
                        <Route
                            path={cPath(
                                "ADMIN.DONATION_TRANSACTION_USER_PAGE",
                                { id: ":id" },
                                true
                            )}
                            element={<DonationTransactionPage />}
                        />
                        <Route
                            path={cPath(
                                "ADMIN.MY_DONATION_TRANSACTION_PAGE",
                                {},
                                true
                            )}
                            element={
                                <div>
                                    <DonationTransactionPage />
                                </div>
                            }
                        />
                        <Route
                            path={cPath("ADMIN.LOGOUT", {}, true)}
                            element={<Logout />}
                        />
                    </Route>
                </>
            ) : (
                <>
                    <Route
                        path="*"
                        element={<Navigate to={cPath("PUBLIC")} replace />}
                    />
                    <Route
                        path={cPath("PUBLIC")}
                        element={
                            <Suspense fallback={<>{t("Loading")}</>}>
                                <LoginLayout />
                            </Suspense>
                        }
                    >
                        <Route
                            path={cPath(
                                "PUBLIC.SECURITY.TOKEN_LOGIN_PAGE",
                                { token: ":token" },
                                true
                            )}
                            element={<TokenLoginPage />}
                        />
                        <Route
                            path={cPath("PUBLIC.SECURITY.LOGIN_PAGE", {}, true)}
                            element={<LoginPage />}
                        />
                        <Route
                            path={cPath(
                                "PUBLIC.SECURITY.FORGOT_PASSWORD_PAGE",
                                {},
                                true
                            )}
                            element={<ForgotPasswordPage />}
                        />
                        <Route
                            path={cPath(
                                "PUBLIC.SECURITY.SET_PASSWORD_PAGE",
                                {},
                                true
                            )}
                            element={<SetPasswordPage />}
                        />
                    </Route>
                </>
            )}
        </Routes>
    );
};

export default RootRoutes;
